const wifiPackagesPath = '/wifi-packages';
export const createWifiPackage = wifiPackagesPath;
export const getWifiPackages = wifiPackagesPath;
export const getWifiPackageById = (id: number) => `${wifiPackagesPath}/${id}`;
export const updateWifiPackage = (id: number) => `${wifiPackagesPath}/${id}`;